/**
 * package: com.inq.flash.client.chatskins
 * class: ScrollMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ScrollMonitor = function () {
};

/* Register this base class to $hxClasses object. */
$hxClasses.registerClass(com.inq.flash.client.chatskins.ScrollMonitor, 'com.inq.flash.client.chatskins.ScrollMonitor');

/**
 * Initializes ScrollMonitor instance,
 * returns true if the monitor has been enabled.
 * The ScrollMonitor will NOT be enabled on mobile browsers.
 *
 * @public
 * @static
 * @see ScrollMonitor.isMobile()
 * @return {boolean} - boolean indicating whether the ScrollMonitor has been enabled.
 */
com.inq.flash.client.chatskins.ScrollMonitor.init = function () {
	com.inq.flash.client.chatskins.ScrollMonitor._initialZoom = com.inq.flash.client.chatskins.ScrollMonitor._zoomPrev
		= com.inq.utils.Capabilities.isMobile() ? com.inq.utils.Capabilities.getZoom() : 0;
	com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure =
		com.inq.utils.Capabilities.isPhone()
			? com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneScroll
			: com.inq.flash.client.chatskins.ScrollMonitor.whenScroll;

	var documentElement = window.parent.document.documentElement;
	if (documentElement.style.height !== "") {
		com.inq.flash.client.chatskins.ScrollMonitor.htmlHeightFromClient = documentElement.style.height;
	}

	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		return false;
	}

	com.inq.flash.client.chatskins.ScrollMonitor._scrollTopPrev = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop();
	com.inq.flash.client.chatskins.ScrollMonitor._scrollLeftPrev = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft();
	com.inq.flash.client.chatskins.ScrollMonitor._vieportWidthPrev = window.top.innerWidth;
	com.inq.utils.Capabilities.setOrigViewPortHeight();

	com.inq.flash.client.chatskins.ScrollMonitor.bindAll();

	return true;
};


/**
 * bindAll - bind all listeners
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.bindAll = function () {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        if (!com.inq.utils.Capabilities.isPhone()) {
			com.inq.utils.Capabilities.BindListener(window.parent, "scroll", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
            com.inq.utils.Capabilities.BindListener(window.parent, "resize", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
            com.inq.utils.Capabilities.BindListener(window.parent, "orientationchange", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
        }
        else {
            /* MOB-539 - Comcast Mobile : Input Box is Hidden After Scrolling The Chat Window
             *	On Safari on iPhone, the clicking at the bottom when the bookmark/navigation bar is not shown, brings back the bookmark/navigation bar.
             *	The document does NOT get the click event so There is NO focus into our Input-Box.  The browser reshows the bookmark/navigation bar overflow the Input-Box.
             *	To make this more agrevating, the window inner height is reduced (by about 38 pixels) and no resize event occurs.  Actually no event occurs.
             *		see http://www.mobilexweb.com/blog/ios-7-1-safari-minimal-ui-bugs
             *	So we must use a Timer and see when the innerHeight changes, when it does, force the re-rendering of the new size.
             *
             *	Why do we use <B>scrollBy</B> instead of the resizing logic in function whenPhoneScroll ????
             *		Because, when we re-render from the Timer event, it renders incorrectly.
             *		What we render is correct.  What the browser renders is incorrectly.
             *		1) The size is correct
             *		2) The positioning is correct: Fixed 0,0
             *		However, the fixed positioning at top of screen is incorrect.  It renders under the "URL/location" bar.
             *
             *		THIS renders correctly from an event thread, But NOT from a timer
             *
             *		that is Why we use scrollBy to force the whenPhoneScroll event handling code.
             */
            var lastHeight = window.parent.innerHeight;
            if (com.inq.utils.Capabilities.isPhone() && com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer == -1) {
                com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer = window.setInterval(function () {
                    if (com.inq.ui.Stage.getInstance().getVisible()
                        && !com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus()
                        && window.parent.innerHeight != lastHeight) {
                        lastHeight = window.parent.innerHeight;
                        window.parent.scrollBy(0, 1);
                        window.parent.scrollBy(0, -1);
                    }
                }, 500);
            }

			com.inq.utils.Capabilities.UnbindListener(window.parent, "touchmove", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
			com.inq.utils.Capabilities.UnbindListener(window.parent, "scroll", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
			com.inq.utils.Capabilities.UnbindListener(window.parent, "orientationchange", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
			
			com.inq.utils.Capabilities.BindListener(window.parent, "touchmove", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
            com.inq.utils.Capabilities.BindListener(window.parent, "scroll", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
            com.inq.utils.Capabilities.BindListener(window.parent, "orientationchange", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
            // rtdev-14953 detect if user zoomed while zoomed message is displayed
            if (com.inq.utils.Capabilities.isIphone() && com.inq.flash.client.chatskins.SkinControl.isInApplication("zoomedScreenMsg")) {
                com.inq.utils.Capabilities.UnbindListener(window.parent, "scroll", com.inq.stage.ViewportMgr.impl.toggleZoomedScreenMsg);
                com.inq.utils.Capabilities.BindListener(window.parent, "scroll", com.inq.stage.ViewportMgr.impl.toggleZoomedScreenMsg);
            }
        }
    }
};


/**
 * unbindAll - unbind all listeners
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.unbindAll = function () {
    if (!com.inq.utils.Util.isFocusAndScrollMonitorsDisabled()) {
        if (com.inq.utils.Capabilities.isPhone() && com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer != -1) {
            clearInterval(com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer);
            com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer = -1;
		}
		com.inq.utils.Capabilities.UnbindListener(window.parent, "touchmove", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
        com.inq.utils.Capabilities.UnbindListener(window.parent, "scroll", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
        com.inq.utils.Capabilities.UnbindListener(window.parent, "resize", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
        com.inq.utils.Capabilities.UnbindListener(window.parent, "orientationchange", com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure);
		if (com.inq.utils.Capabilities.isIphone()) {
			// rtdev-14953 detect if user zoomed while zoomed message is displayed
			if (com.inq.flash.client.chatskins.SkinControl.isInApplication("zoomedScreenMsg")) {
				com.inq.utils.Capabilities.UnbindListener(window.parent, "scroll", com.inq.stage.ViewportMgr.impl.toggleZoomedScreenMsg);
			}
			com.inq.flash.client.chatskins.ScrollMonitor.removeAutoHeight();
		}
    }
};


/**
 * Close
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.Close = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.unbindAll();
};


/**
 * suspend
 * Ignore scroll events until resume() is called.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.suspend = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.suspendedLevel++;
};


/**
 * resume
 * Resume listening for scroll events.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.resume = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.suspendedLevel--;
};


/**
 * isSuspended
 *
 * RTDEV-8556:
 *    For the iPad we are disabling the isSuspended, in a way.  We will always return false (not suspended).
 *    The suspend logic has a long delay where "listening" to scroll, orientation, and resize events are suspended
 *    This causes the "missing" of events that control the correct positioning of the CI on the iPad
 *    The suspend logic was added by Chris Raser (craser@touchcommerce.com) for MOB-179 for a problem that was iPhone specific.
 * @see http://jira.touchcommerce.com/browse/RTDEV-8556
 * @see http://jira.touchcommerce.com/browse/MOB-179
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ScrollMonitor.isSuspended = function () {
	return (com.inq.utils.Capabilities.isIpad()) ? false
		: com.inq.flash.client.chatskins.ScrollMonitor.suspendedLevel > 0;
};


/**
 * ScrollToPoint
 *
 * @public
 * @static
 * @param {com.inq.utils.Point}  p
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollToPoint = function (p) {
	com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(p.x, p.y);
};


/**
 * ScrollTo
 * Scroll the page to the given coordinates.  Ignore the resulting
 * scroll event.
 *
 * @public
 * @static
 * @param {number}  x
 * @param {number}  y
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo = function (x, y) {
	com.inq.flash.client.chatskins.ScrollMonitor.suspend();
	/*  Stop listening to scroll events.*/
	try {
		window.parent.scrollTo(x, y);
	}
	catch (err) {
		haxe.Log.trace("Error: " + err);
	}
	window.setTimeout(com.inq.flash.client.chatskins.ScrollMonitor.resume, 100);
	/*  Wait 0.1 sec, then start listening again.*/
};


/**
 * Scrolls the page by the given offsets.
 *
 * @param {number} dx The x offset to scroll by.
 * @param {number} dy The y offset to scroll by.
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollBy = function (dx, dy) {
	com.inq.flash.client.chatskins.ScrollMonitor.suspend(); // Stop listening to scroll events.
	try {
		window.parent.scrollBy(dx, dy);
	}
	catch (e) {
		haxe.Log.trace("Error: " + err);
	}
	window.setTimeout(com.inq.flash.client.chatskins.ScrollMonitor.resume, 100);
	/*  Wait 0.1 sec, then start listening again.*/
};

/**
 * ScrollToTop
 * Scrolls to top left corner of the page.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollToTop = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(0, 0);
};


/**
 * ScrollToNearTop
 * Scroll to the first pixel after top, to remove the location bar
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollToNearTop = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(0, 1);
};


/**
 * ScrollToBottom - scroll the page all the way to the bottom.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.ScrollToBottom = function () {
	/** @type {com.inq.utils.Point} */
	var windowPosition = com.inq.utils.Capabilities.getViewport();
	/*  Remember this so that we can restore it later in onBlur*/
	com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(windowPosition.x, window.parent.document.documentElement.offsetHeight);
};


/**
 * notify
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.notify = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.whenScroll(null);
};


/**
 * whenScroll
 *
 * @private
 * @static
 * @param {null}  e
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ScrollMonitor.whenScroll = function (e) {
	if (com.inq.flash.client.chatskins.ScrollMonitor.isSuspended()) {
		return true;
		/*  Don't move the CI if we're persistent*/
	}

	/* If we are moving the chat due to a resize or an orientation change, let's not have a big one-second delay, the delay was meant for scrolling
	 * We must check the event for existance because this is also called by the notify method with a null as the event
	 */
	if (!e) e = window.parent.Event;
	/** @type {boolean} */
	var fastMove = false;
	/** @type {boolean} */
	var forceMove = false;

	/* When we get an orientation change, we will:
	 * remove focus from input field to lower the virtual keyboard
	 * set forceMove which will force the recalculation of the position,
	 * store the current position, old one was based on a different orientation and viewport
	 * restore the position if auto-scroll happens due to focused text field.
	 *
	 * Why are we checking for "orientationchange" and "resize" ?
	 * The orientation change causes a resize, the orientationchange event happens after the resize
	 * The iPad's iOS can make the input field with focus come into view and will scroll the page to do this
	 * This makes the chat "hide" from view.  So when we see this happen, we restore the scroll position.
	 * We are checking for iPad so we can limit testing
	 * If needed it can be for all mobile devices
	 */
	if (com.inq.flash.client.chatskins.ScrollMonitor._iPadSafariOrChrome &&
		e && e.type && (e.type == "orientationchange" || e.type == "resize")) {
		fastMove = true;
		forceMove = true;
	}

	//RTDEV 5493 - do nothing if minimized so functions upon restore
	if (!com.inq.ui.Stage.getInstance().getVisible()) {
		return true;
	}
	else if (com.inq.flash.client.chatskins.ScrollMonitor._iPadSafariOrChrome) {
		/* THIS is a scroll de-bounce.  If the scroll has been idle for one Second,
		 Then we move the chat.
		 We do this by:
		 * issuing a one Second timer
		 * if scroll event happens before timer fires, we cancel the timer and reissue.
		 MOB-735: iPad : Safari : Div layer chat window does not float as the customer scrolls down the page when keyboard is on the screen
		 */
		if (fastMove) {
			com.inq.flash.client.chatskins.ScrollMonitor.moveChat(forceMove, e.type);
			return true;
		}

		if (com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll != -1) {				// If we have an active timer, we cancel it
			window.clearTimeout(com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll);	// cancel it
			com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll = -1;					// set it to minus one, signifying no active timer
		}

		if (com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll == -1) {
			com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll = window.setTimeout(function () {	// set timer for one second
				com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll = -1;							// when we fire, we set the timer to minus one to signify that it is not active
				com.inq.flash.client.chatskins.ScrollMonitor.moveChat();									// ... and we move the chat.
			}, (fastMove) ? 1 : 500);
		}

	}
	else {
		com.inq.flash.client.chatskins.ScrollMonitor.numWaiting++;
		var eventType = e.type;
		window.setTimeout(function () {
			com.inq.flash.client.chatskins.ScrollMonitor.handleRapidScroll(eventType);
		}, 25);
		return true;
	}
};

/**
 * whenPhoneScroll
 *
 * NOTE: There is an issue when a user Scrolls to the top of the screen...
 *       The navigation bar shows up and the viewport gets smaller.
 *       We will check for the top of the screen and restestablish the viewport size
 *
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneScroll = function () {
	/**
	 * @see http://jira.touchcommerce.com/browse/RTDEV-14510
	 * Refer to the function com.inq.flash.client.control.MinimizeManager.actionRestore() for explanation  about this fix
	 */
	if (com.inq.flash.client.control.MinimizeManager.onActionRestore && !com.inq.addons.Salesforce.isStarted()) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.setHasFocus();
	}
	com.inq.flash.client.chatskins.ChatTextFocusMonitor.onScrollCallback();
	if (com.inq.flash.client.chatskins.ScrollMonitor.isSuspended()) return true;
	/*  Don't move the CI if we're persistent*/

	/* Make sure that the application is visible.
	 * If not visible then remove the scroll monitors.
	 */
	if (!com.inq.ui.Stage.getInstance().getVisible()) {
		com.inq.flash.client.chatskins.ScrollMonitor.Close();
		return true;
	}

	/* If orientationchange or scroll to zero or scroll from zero top,
	 * Then we needs to recalculate the size of the viewport
	 */

	/* If the user has scrolled to the very top, then the location bar will be visible once more
	 * making the viewport change size */
	/** @type {number} */
	var oldHeight = Application.application.area.h;
	/** @type {com.inq.utils.Area} */
	var vpArea = com.inq.utils.Capabilities.getViewport();

	if (!com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus() && (vpArea.h != oldHeight)) {
		Application.MoveSizeDiv2Stage(vpArea.w,
			vpArea.h,
			Application.application.area.x,
			Application.application.area.y);
		Application.Resize();
	}
	com.inq.utils.Timer.delay(function () {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.FixIPhoneFocusScroll();
	}, 100);

	window.setTimeout(com.inq.flash.client.chatskins.ScrollMonitor.autoScrollOutOfViewElement, 500);
};

/**
 * autoScrollOutOfViewElement
 *
 * This function acts on those elements which are hidden under the soft keyboard and yet have focus.
 * Such an out of view element is identified and it is scrolled up so that it is visible.
 * Note that the scrolling happens only within the container and not directly on
 * the client page (so scroll and focus monitors will not fire)
 *
 * Such situations occurs only in the post-chat and pre-chat survey caused by the scroll monitors.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.autoScrollOutOfViewElement = function () {
	var el = parent.document.activeElement;  //consider the element in focus
	if (com.inq.flash.client.chatskins.ChatTextFocusMonitor.getImpl().isInputElement(el)) {
		var rect = el.getBoundingClientRect();
		// The actual height calculated by subtracting the keyboard height
		var actualHeight = com.inq.flash.client.chatskins.ChatTextFocusMonitor.calculateViewableArea();
		var vp = com.inq.utils.Capabilities.getViewport();

		// only acts on those elements which are located under the soft keyboard
		if (rect.y > 0 && rect.y > actualHeight && rect.y < vp.h) {
			var container = com.inq.utils.Util.getScrollableContainer(el); // get the scrollable container..
			if (container) {
				container.scrollBy(0, rect.y - (actualHeight / 2));// scroll it to the center
			}
		}
	}
};

/**
 * whenPhoneScroll
 *
 * NOTE: There is an issue when a user Scrolls to the top of the screen...
 *       The navigation bar shows up and the viewport gets smaller.
 *       We will check for the top of the screen and restestablish the viewport size
 *
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneChangedHeight = function () {
	/** @type {number} */
	var oldHeight = Application.application.area.h;
	/** @type {com.inq.utils.Area} */
	var vpArea = com.inq.utils.Capabilities.getViewport();

	if (!com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus() && (vpArea.h != oldHeight)) {
		Application.MoveSizeDiv2Stage(vpArea.w,
			vpArea.h,
			Application.application.area.x,
			Application.application.area.y);
		Application.Resize();
	}
};


/**
 * waitForLull
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function waitForLull():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.waitForLull = function () {
	com.inq.flash.client.chatskins.ScrollMonitor.waitingForLull = true;
};


/**
 * handleRapidScroll
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function handleRapidScroll()
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.handleRapidScroll = function (type) {
	if (com.inq.flash.client.chatskins.ScrollMonitor.isSuspended()) {
		return;
	}
	else if (--com.inq.flash.client.chatskins.ScrollMonitor.numWaiting > 0) return;
	/*  Decrement numWaiting and test.*/
	if (com.inq.flash.client.chatskins.ScrollMonitor.waitingForLull) {
		com.inq.flash.client.chatskins.ScrollMonitor.waitingForLull = false;
		/*  Quit waiting for a lull.*/
		com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition();
		/*  But DO remember where we are.*/
	}
	else {
		com.inq.flash.client.chatskins.ScrollMonitor.moveChat(false, type);
	}
	/*  Not waiting for lull, and all rapid-fire scroll events are done.*/
};


/**
 * moveChat
 *
 * Move chat upon scroll event
 *
 * TODO According to Fred and I think, ScrollMonitor should be not in play on Phone devices which viewportMgr is used.
 *     iPhone still needs this called upon scroll event.
 *     For now, I just removed portion for Android Phone.
 *
 * @private
 * @static
 * @param 	{Boolean=} forceMove
 * @param   {?=} type
 * @return 	{void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.moveChat = function (forceMove, type) {
	/* If the move puts the chat in a non-visible area, then we must move it so it can be seen (RTDEV-8556) */
	if(!forceMove) forceMove = false;
	/** @type {number} */
	var relLeft;
	/** @type {number} */
	var relTop;

	if (!com.inq.utils.Capabilities.isMobile()) {
		relLeft = com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft() - com.inq.flash.client.chatskins.ScrollMonitor._scrollLeftPrev;
		relTop = com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop() - com.inq.flash.client.chatskins.ScrollMonitor._scrollTopPrev;
		Application.ScrollStage(relLeft, relTop);
		com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition();
	}
	else if (com.inq.utils.Capabilities.isIphone() && !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport("ScrollMonitor.moveChat");
		/*  Snap to screen size for phones.*/
	}
	else if (com.inq.utils.Capabilities.isTablet()) {
		/** @type {com.inq.utils.Area} */
		var vp = com.inq.utils.Capabilities.getViewport();
		var z = com.inq.utils.Capabilities.getZoom();
		relLeft = vp.x - com.inq.flash.client.chatskins.ScrollMonitor._scrollLeftPrev;
		relTop = vp.y - com.inq.flash.client.chatskins.ScrollMonitor._scrollTopPrev;
		/** @type {number} */
		var preVW = com.inq.flash.client.chatskins.ScrollMonitor._vieportWidthPrev;

		/* RTDEV-8556 - Make sure that the chat is in a visible area
		 Do not move it out of view

		 So if the chat is:
		 1) Above the top of the viewable area, move it down into view
		 2) To the left of the viewable area, move it to the right into view
		 3) At the bottom of the screen outside of viewable area, move it up into view
		 4) To the right of the screen outside the viewable area, move it left into view
		 */

		try {
			var offsetLeft = com.inq.ui.Stage.getStageLeft(); 			// Get the left position of the chat window (stage)
			var offsetTop = com.inq.ui.Stage.getStageTop(); 				// Get to top position of the chat window (stage)

			/* Make sure that the Chat is not outside visible area, to the left or right
			 * So we calculate the maxRight and right and see if we are past the max.
			 * And of course we do the same for the bottom as well
			 */
			var width = Application.application.getWidth();
			/* Get the width of the chat box */
			var height = Application.application.getHeight();
			/* Get the height of the chat box */
			var right = offsetLeft + width;
			/* Calculate the right border location  of the chat box*/
			var maxRight = vp.x + vp.w;
			/* Calculate the maximum right border of the chat box (actually the right border of the visible area */
			/**
			 * @see http://jira.touchcommerce.com/browse/RTDEV-9267
			 */
			var bottom = offsetTop + relTop + height;
			/* Calculate the bottom border of the chat */
			var maxBottom = vp.y + vp.h;
			/* Calculate the bottom border of the visible page */

			/**@type {HTMLInputElement}**/
			var currentFocusEl = com.inq.flash.client.chatskins.ChatTextFocusMonitor.getFocusElement();
			/**@type {Integer}**/
			var focElemeentOffTop = 0;
			/** @type {Integer} */
			var clientbodyWidth = window.parent.document.body.clientWidth;
			if (currentFocusEl && currentFocusEl.id.indexOf("email") != -1) {
				focElemeentOffTop = Application.application.getMxmlItem("emailInput").getOffsetTop();
			}

			if(currentFocusEl && (currentFocusEl.nodeName.toUpperCase() == "INPUT" || currentFocusEl.nodeName.toUpperCase() == "TEXTAREA")) {
				focElemeentOffTop = com.inq.flash.client.chatskins.ScrollMonitor.getOffsetTopToStage(currentFocusEl);
			}

			if (type
				&& (type == "orientationchange"
					|| (type == "resize" && (com.inq.utils.Capabilities.isAndroid()
						|| com.inq.utils.Capabilities.isChromeiOS10()
						|| com.inq.utils.Capabilities.isChromeiOS11()
						|| com.inq.utils.Capabilities.isChromeiOS12()
						|| com.inq.utils.Capabilities.isChromeiOS13()
						|| com.inq.utils.Capabilities.isChromeiOS14())))
				&& (com.inq.flash.client.chatskins.ScrollMonitor._initialZoom != z || right > clientbodyWidth || preVW != vp.w || offsetTop < vp.y)) {

				com.inq.flash.client.chatskins.ScrollMonitor._initialZoom = z;
				recalculate();
			}
			else if ((( type == "scroll" || type == "resize" || forceMove) && com.inq.utils.Capabilities.isAndroid()) && (preVW != vp.w || offsetTop < vp.y)) {
				vp.x = vp.x != 0 ? clientbodyWidth - window.parent.document.body.scrollWidth : 0;
			}
			else if (com.inq.utils.Capabilities.isAndroid() && z <= com.inq.flash.client.chatskins.ScrollMonitor._initialZoom && vp.x + Application.initialXPos > maxRight) {
				currentFocusEl && currentFocusEl.blur();
			}

			if (com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched && com.inq.utils.Capabilities.isIpad()) {
				maxBottom -= com.inq.flash.client.chatskins.ScrollMonitor.getKeyboardHeightOfIPad();
			}
			/**
			 * @description RTDEV-9875; if the page zoom changes then calculate position using the initial position value when the chat started for the first time.
			 */
			if (z <= com.inq.flash.client.chatskins.ScrollMonitor._initialZoom) {
				var maxH = vp.y + Application.initialYPos + height;
				com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition();
				/**
				 * RTDEV-16573
				 * Fix the Y position in the "if" part of the previous code with cause this problme.
				 * The following calculation of the yPos was extracted from the else part of the previous code
				 * so it can be used by Application.ScrollStageRelPage.  Also, we don't need the if/else since the
				 * logic is the same for both.
				 */

				var yPos = vp.y + Application.initialYPos;
				if(maxH > maxBottom) {
					yPos -= (maxH-maxBottom);
				}
				if (vp.y <= 1 && yPos < 0) {
					yPos = 0;
				}
				else {
					if (yPos + focElemeentOffTop < vp.y) {
						yPos += (vp.y-yPos) - focElemeentOffTop;
					}
				}

				Application.ScrollStageRelPage(vp.x + Application.initialXPos, yPos);
				return;
			}
			/* fix for chat jumping issue when page is zoomed in and zoomed out */
			if (z != com.inq.flash.client.chatskins.ScrollMonitor._zoomPrev) {
				var posX = offsetLeft, posY = offsetTop;

				if (right > maxRight) {
					posX = offsetLeft - (right - maxRight);
				}
				if (offsetTop < vp.y) {
					posY = vp.y;
				}
				if ((offsetTop + height) > maxBottom) {
					posY = offsetTop - ((offsetTop + height) - maxBottom);
				}
				if (offsetLeft < vp.x) {
					posX = vp.x;
				}
				if (posX != offsetLeft || posY != offsetTop) {
					Application.ScrollStageRelPage(posX, posY);
				}
				com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition();
				return;
			}
			/**
			 * end of @description RTDEV-9875
			 */

			/* If the right is past the maximum right, then adjust the relLeft value */
			if (right > maxRight) {
				/* Set the forceMove flag, to ensure the moving of the incorrectly positioned chat */
				forceMove = true;
				/* Fix the relLeft value by the amount that the chat is past the right border */
				relLeft += maxRight - right;
			}


			/* If we are past the bottom of the visible page, them we must move the chat upwards */
			if (bottom > maxBottom) {
				/* We must move */
				forceMove = true;
				/* Adjust the relTop by the overage */
				relTop += maxBottom - bottom;
			}


		}
		catch (er) {
			haxe.Log.trace("Error in ScrollMonitor moveChat: " + er, {
				fileName: "ScrollMonitor.js",
				lineNumber: 656,
				className: "com.inq.flash.client.chatskins.ScrollMonitor",
				methodName: "moveChat"
			});
		}

		if (forceMove || z == com.inq.flash.client.chatskins.ScrollMonitor._zoomPrev) Application.ScrollStageInPage(relLeft, relTop);
		/*  Only move if the user is NOT zooming in/out.*/
		com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition();
	}
	/*  Other mobile clients.*/

	/**
	 * function to recalculate chat position when orientation changes
	 */
	function recalculate() {
		var skinControl = com.inq.flash.client.chatskins.SkinControl;
		var position = Application.calcChatLocation(skinControl.getSkinWidth(),
													skinControl.getSkinHeight() + skinControl.getTitleBarHeight(),
													skinControl.getSkinLeft(),
													skinControl.getSkinTop(),
													skinControl.getSkinLocation());
		Application.initialXPos = position.x - vp.x;
		Application.initialYPos = position.y - vp.y;
		if (Application.initialXPos + width > clientbodyWidth) {
			Application.initialXPos -= (Application.initialXPos + width) - clientbodyWidth;
		}
		if (Application.initialXPos + width > window.top.innerWidth) {
			Application.initialXPos -= (Application.initialXPos + width) - window.top.innerWidth;
		}
	}
};

/**
 * Calculates keyboard height, which affects web-page and chat elements
 *
 * We cannot get the keyboard height of iPad, because it is a program element. We calculate the keyboard height
 * through screen percentages that are covered by the keyboard. The iPad also has a feature that increase height of a web-page
 * when users are at the bottom of the page and the keyboard is displayed. We reduce keyboard height by added height.
 *
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getKeyboardHeightOfIPad = function () {

	/** @type {com.inq.utils.Area} */
	var vp = com.inq.utils.Capabilities.getViewport();
	/** @type {number} */
	var systemElementsHeight = com.inq.utils.Capabilities.isSafari() ?
		com.inq.flash.client.chatskins.ScrollMonitor.SYSTEM_BAR_HEIGHT.safari :
		com.inq.flash.client.chatskins.ScrollMonitor.SYSTEM_BAR_HEIGHT.chrome;
	var viewportHeight = com.inq.utils.Capabilities.getScreenHeight() - systemElementsHeight;
	/** @type {number} */
	var keyboardHeight = (com.inq.utils.Capabilities.getOrientation() ?
		com.inq.flash.client.chatskins.ScrollMonitor.IPAD_KEYBOARD_HEIGHT_PRESENTAGES.portrait :
		com.inq.flash.client.chatskins.ScrollMonitor.IPAD_KEYBOARD_HEIGHT_PRESENTAGES.landscape) / 100 * viewportHeight;
	/** @type {number} */
	var keyboardHeightFix = keyboardHeight - (viewportHeight - vp.h);

	return (keyboardHeightFix > 0) ? keyboardHeightFix : 0;
};

/**
 * storeCurrentPosition
 * Stores the current position and zoom.
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function storeCurrentPosition():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.ScrollMonitor.storeCurrentPosition = function () {
	var vp = com.inq.utils.Capabilities.getViewport(); 		/** @type {com.inq.utils.Area} */
	var z = com.inq.utils.Capabilities.getZoom(); 			/** @type {number} */
	com.inq.flash.client.chatskins.ScrollMonitor._scrollLeftPrev = vp.x;
	com.inq.flash.client.chatskins.ScrollMonitor._scrollTopPrev = vp.y;
	com.inq.flash.client.chatskins.ScrollMonitor._zoomPrev = z;
	com.inq.flash.client.chatskins.ScrollMonitor._vieportWidthPrev = vp.w;
};


/**
 * getScrollWidth
 *
 * Return client page usable width;
 *   First, check parent.innerWidth.
 *   if it is null, Second use parent.documentElement.clientWidth if it is not null or 0
 *   Last, use parent.document.body.clientWidth.
 *
 *   SEE Capabilities.getViewport
 *
 * @public
 * @static
 * @param     clientWin - argument for unit test to represent window.parent.
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollWidth = function (clientWin) {
	if (!clientWin) clientWin = window.parent;
	var clientDoc = clientWin.document;
	var iScrollWidth = 0;

	if (null == clientWin["innerWidth"]) {
		iScrollWidth = clientDoc["documentElement"] != null ?
					   0 != clientDoc.documentElement.clientWidth ?
					   clientDoc.documentElement.clientWidth
						   : clientDoc.body.clientWidth
			: clientDoc.body.clientWidth;
	}
	else {
		var innerWidth = clientWin.innerWidth;
		// If necessary, adjust innerWidth to reflect the presence of the scroll bar.
		innerWidth -=
			Application.hasRightScrollBar() ? com.inq.flash.client.chatskins.ScrollMonitor.getScrollBarWidth() : 0;
		var clientWidth = clientDoc.body.clientWidth;
		/** on a Tablet we should use innerwidth as the scroll width because as user zooms in innerwidth shrinks and as user zoom out innerwidth expands. */
		if (com.inq.utils.Capabilities.isTablet()) {
			iScrollWidth = innerWidth;
		}
		else {
			iScrollWidth = (clientWidth == 0) ? innerWidth : Math.min(clientWidth, innerWidth);
		}
		if (0 == iScrollWidth) iScrollWidth = clientDoc.body.clientWidth;
	}
	return iScrollWidth;
};


/**
 * getScrollHeight
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollHeight = function () {
	var iScrollHeight = 0;
	var clientDoc = window.parent.document;

	if (null == window.parent["innerHeight"]) {
		iScrollHeight = clientDoc["documentElement"] != null
			? 0 != clientDoc.documentElement.clientHeight ? clientDoc.documentElement.clientHeight
							: clientDoc.body.clientHeight
			: clientDoc.body.clientHeight;
	}
	else {
		var innerHeight = window.parent.innerHeight;
		// If necessary, adjust innerHeight to reflect the presence of the scroll bar.
		innerHeight -=
			Application.hasBottomScrollBar() ? com.inq.flash.client.chatskins.ScrollMonitor.getScrollBarWidth() : 0;

		// BEWARE browser bugs: clientHeight often reflects a value more like offsetHeight, NOT the correct,
		// visible height of the element. When this happens, it's too BIG, so we apply Math.min below.
		var clientHeight = clientDoc.body.clientHeight;
		var scrollHeight = clientDoc.body.scrollHeight;

		// We need to make sure the page is long enough to fill the screen. If it's not, then the clientHeight
		// is useless. We detect this by checking that the clientHeight >= scrollHeight.
		iScrollHeight = 0;
		if (clientHeight == 0 || scrollHeight >= clientHeight) { // Ensures that the page is tall enough to fill the window
			iScrollHeight = innerHeight;
		}
		else {
			iScrollHeight = Math.min(clientHeight, innerHeight);
		}

		if (0 == iScrollHeight) {
			iScrollHeight =
				clientDoc.body.clientHeight;
		}
	}
	return iScrollHeight;
};


/**
 * Returns a Point representing the current scroll location of the screen.
 *
 * @return {com.inq.utils.Point} Curent scroll location of the screen.
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollPoint = function () {
	// TODO: REFACTOR THIS!
	return new com.inq.utils.Point(
		com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft(),
		com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop()
	);
};


/**
 * getScrollTop
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollTop = function () {
	var clientWin = window.parent;
	var clientDoc = clientWin.document;

	try {
		if (null != clientWin["pageYOffset"]) {
			return clientWin.pageYOffset;
		}

		if (clientDoc["documentElement"] != null && (clientDoc.documentElement["scrollTop"] != null && clientDoc.documentElement.scrollTop != 0)) {
			return clientDoc.documentElement.scrollTop;
		}
		else {
			return clientDoc.body.scrollTop;
		}
	} catch (msg) {
		if (js.Boot.__instanceof(msg, String)) {
			haxe.Log.trace("error in ScrollMonitor getScrollTop: " + msg, {
				className: "com.inq.flash.client.chatskins.ScrollMonitor",
				methodName: "getScrollTop"
			});
		}
		else {
			throw(msg);
		}
	}
	return 0;
};


/**
 * getScrollLeft
 *
 * Returns an integer representing the number of pixels that document has already been scrolled horizontally.
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollLeft = function () {
	try {
		var clientWin = window.parent;
		var clientDoc = clientWin.document;
		if (null != clientWin["pageXOffset"]) {
			return clientWin.pageXOffset;
		}
		if (clientDoc["documentElement"] != null && (clientDoc.documentElement["scrollLeft"] != null
			&& clientDoc.documentElement.scrollLeft != 0)) {
			return clientDoc.documentElement.scrollLeft;
		}
		else {
			return clientDoc.body.scrollLeft;
		}
	} catch (msg) {
		if (js.Boot.__instanceof(msg, String)) {
			haxe.Log.trace("error in ScrollMonitor getScrollLeft: " + msg, {
				fileName: "ScrollMonitor.hx",
				lineNumber: 279,
				className: "com.inq.flash.client.chatskins.ScrollMonitor",
				methodName: "getScrollLeft"
			});
		}
		else {
			throw(msg);
		}
	}
	return 0;
};


/**
 * getScrollBarWidth
 * Calculates browser scroll bar width in pixels.
 * We add div out of scroll area (-1000px) and then add one more div with width 100%
 * Then set overflow type as "auto" and then get div width + scrollbar width
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.flash.client.chatskins.ScrollMonitor.getScrollBarWidth = function () {
	/** @type {Element} */
	var scr;
	/** @type {Element} */
	var inn;
	/** @type {number} */
	var wNoScroll;
	/** @type {number} */
	var wScroll;

	/*  Outer scrolling div */
	scr = window.parent.document.createElement("div");
	scr.style.position = "absolute";
	scr.style.top = "-1000px";
	scr.style.left = "-1000px";
	scr.style.width = "100px";
	scr.style.height = "50px";
	/*  Start with no scrollbar */
	scr.style.overflow = "hidden";

	/*  Inner content div */
	inn = window.parent.document.createElement("div");
	inn.style.width = "100%";
	inn.style.height = "200px";

	/*  Put the inner div in the scrolling div */
	scr.appendChild(inn);
	/*  Append the scrolling div to the doc */

	window.parent.document.body.appendChild(scr);

	/*  Width of the inner div sans scrollbar */
	wNoScroll = inn.offsetWidth;
	/*  Add the scrollbar */
	scr.style.overflow = "auto";
	/*  Width of the inner div width scrollbar */
	wScroll = inn.offsetWidth;

	/*  Remove the scrolling div from the doc */
	window.parent.document.body.removeChild(window.parent.document.body.lastChild);

	/*  Pixel width of the scroller */
	return wNoScroll - wScroll;
};

com.inq.flash.client.chatskins.ScrollMonitor.getOffsetTopToStage = function(el) {
	var stageDiv = com.inq.ui.Stage.getStageElement(),offsetT = 0;
	if (stageDiv && stageDiv.getBoundingClientRect) {
		offsetT = Math.abs(stageDiv.getBoundingClientRect().top - el.getBoundingClientRect().top);
	}
	return offsetT;
};

/**
 * Used to add height style to the client page.
 */
com.inq.flash.client.chatskins.ScrollMonitor.addAutoHeight = function() {
	var clientDoc =  window.parent.document;
	var clientBody = clientDoc.body;
	var clientDocEl = clientDoc.documentElement;
	if (clientDocEl.clientHeight <= clientBody.clientHeight) {
		clientDocEl.style.height = "auto";
	}
};

/**
 * Used to remove height style from client page.
 */
com.inq.flash.client.chatskins.ScrollMonitor.removeAutoHeight = function() {
	var clientDoc =  window.parent.document;
	var clientDocEl = clientDoc.documentElement;
	if (com.inq.flash.client.chatskins.ScrollMonitor.htmlHeightFromClient != null) {
		clientDocEl.style.height = com.inq.flash.client.chatskins.ScrollMonitor.htmlHeightFromClient;
		com.inq.flash.client.chatskins.ScrollMonitor.htmlHeightFromClient = null;
	} else {
		clientDocEl.style.height = "";
	}
};

/** @type {com.inq.flash.client.chatskins.ScrollMonitor} */
com.inq.flash.client.chatskins.ScrollMonitor.prototype.__class__ = com.inq.flash.client.chatskins.ScrollMonitor;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor.numWaiting = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor.sizeChangeEventTimer = -1;

/** @private @type {number} */
// on ipad if this value is 0 then restore button, and text input from minimized will not get focus.
// To improve user experience you need to enhance ScrollMonitor.
com.inq.flash.client.chatskins.ScrollMonitor.suspendedLevel = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._scrollTopPrev = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._scrollLeftPrev = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._vieportWidthPrev = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._zoomPrev = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._initialZoom = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.ScrollMonitor._timerIdScroll = -1;

/** @private @type {null} */
com.inq.flash.client.chatskins.ScrollMonitor.whenScrollClosure = null;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.ScrollMonitor.waitingForLull = false;

/* Check for version 8 through 10 of Safari  or Chrome for iOS */
/** @type {boolean} */
com.inq.flash.client.chatskins.ScrollMonitor._iPadSafariOrChrome =
	((/(iPad).*AppleWebKit?.*Version\/(6|7|8|9)/i).test(navigator.userAgent)) ||
	(/(iPad).*AppleWebKit?.*CriOS/i.test(navigator.userAgent));

/**
 * Height of the system bar in Safari and Google Chrome
 * @type {Object}
 */
com.inq.flash.client.chatskins.ScrollMonitor.SYSTEM_BAR_HEIGHT = {
	safari: 80,
	chrome: 125
};
/**
 * The percentages of keyboard height from the original height of the iPad.
 * @type {Object} */
com.inq.flash.client.chatskins.ScrollMonitor.IPAD_KEYBOARD_HEIGHT_PRESENTAGES = {
	portrait: 33,
	landscape: 65
};

/** @type {?string} */
com.inq.flash.client.chatskins.ScrollMonitor.htmlHeightFromClient = null;
